// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"cebfcba8","239":"7953f36e","453":"e5f869cf","455":"abe1ab69","557":"cc971fcf","745":"abaf598e","884":"f49bc838"}[chunkId] + ".chunk.js";
};